import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SharedModule} from 'app/shared/shared.module';
import {DccNavigationComponent} from './components/dcc-navigation/dcc-navigation.component';
import {AdTypeFilterComponent} from './features/line-items-editor/components/ad-type-filter/ad-type-filter.component';
import {NzPopoverModule} from 'ng-zorro-antd/popover';
import {AppPageNavigationCommonLinksComponent} from './components/app-page-navigation-common-links/app-page-navigation-common-links.component';
import {DropZoneComponent} from './components/drop-zone/drop-zone.component';
import {LineItemComponent} from './components/line-item/line-item.component';
import {LineItemConfiguratorComponent} from './components/line-item-configurator-base/line-item-configurator.component';
import {LineItemConfiguratorCustomComponent} from './components/line-item-configurator-custom/line-item-configurator-custom.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {DccPermissionGuard} from 'app/features/dcc/guards/dcc-permission.guard';

@NgModule({
    imports: [CommonModule, SharedModule, RouterModule, NzPopoverModule, DragDropModule],
    declarations: [
        AdTypeFilterComponent,
        DccNavigationComponent,
        AppPageNavigationCommonLinksComponent,
        DropZoneComponent,
        LineItemComponent,
        LineItemConfiguratorComponent,
        LineItemConfiguratorCustomComponent,
    ],
    exports: [
        AdTypeFilterComponent,
        DccNavigationComponent,
        AppPageNavigationCommonLinksComponent,
        DropZoneComponent,
        LineItemComponent,
        LineItemConfiguratorComponent,
        LineItemConfiguratorCustomComponent,
    ],
    providers: [DccPermissionGuard],
})
export class DccModule {}
